import React from 'react';
import { View, ViewProps } from 'react-native';

import { useColors } from '../hooks/lesson-player.context';
import type { ColorsType } from '../interfaces/colors.type';

export interface ThemedViewProps extends ViewProps {
  children?: any;
  type?: keyof ColorsType;
}

export function ThemedView({ type = 'primary', ...props }: ThemedViewProps) {
  const colors = useColors();
  const color = colors[type];

  return (
    <View style={[{ backgroundColor: color }, props.style]}>
      {props.children}
    </View>
  );
}
